import PropTypes from 'prop-types';

function LeagueProgressBar({
  rankInTier, totalInTier, promotionZone, relegationZone,
}) {
  if (totalInTier === 0) return null;

  // Not enough players for promotion/relegation zones
  if (totalInTier < 5) {
    return (
      <div className="w-full">
        <div className="relative h-6 bg-puzzle-muted rounded-full overflow-hidden">
          <div
            className="absolute top-0.5 h-5 w-5 rounded-full border-2 border-white shadow-md bg-puzzle-blue"
            style={{ left: 'calc(50% - 10px)' }}
          />
        </div>
        <div className="text-center mt-1 text-xs text-puzzle-text-secondary">
          Rank
          {' '}
          {rankInTier}
          {' '}
          of
          {' '}
          {totalInTier}
          {' '}
          &mdash; need 5+ players for promotion/relegation
        </div>
      </div>
    );
  }

  const position = ((rankInTier - 1) / (totalInTier - 1)) * 100;
  const promotionLine = 20; // top 20%
  const relegationLine = 80; // bottom 20%

  return (
    <div className="w-full">
      <div className="relative h-6 bg-puzzle-muted rounded-full overflow-hidden">
        {/* Promotion zone (green) */}
        <div
          className="absolute left-0 top-0 h-full bg-green-500/20"
          style={{ width: `${promotionLine}%` }}
        />
        {/* Relegation zone (red) */}
        <div
          className="absolute right-0 top-0 h-full bg-red-500/20"
          style={{ width: `${100 - relegationLine}%` }}
        />
        {/* Position marker */}
        <div
          className={`absolute top-0.5 h-5 w-5 rounded-full border-2 border-white shadow-md transition-all duration-500 ${
            // eslint-disable-next-line no-nested-ternary
            promotionZone ? 'bg-green-500' : relegationZone ? 'bg-red-500' : 'bg-puzzle-blue'
          }`}
          style={{ left: `calc(${position}% - 10px)` }}
        />
      </div>
      <div className="flex justify-between mt-1 text-xs text-puzzle-text-secondary">
        <span className="text-green-600">Promote</span>
        <span>
          Rank
          {' '}
          {rankInTier}
          {' '}
          of
          {' '}
          {totalInTier}
        </span>
        <span className="text-red-600">Relegate</span>
      </div>
    </div>
  );
}

LeagueProgressBar.propTypes = {
  rankInTier: PropTypes.number.isRequired,
  totalInTier: PropTypes.number.isRequired,
  promotionZone: PropTypes.bool,
  relegationZone: PropTypes.bool,
};

LeagueProgressBar.defaultProps = {
  promotionZone: false,
  relegationZone: false,
};

export default LeagueProgressBar;
